import { Grid } from "@mui/material";
import React from "react";
import VEBBeneficiary from "../../VEBBeneficiary/VEBBeneficiary";

type EditFamilyProtectionBeneficiary = {
	employeePrimaryBeneficiary: any;
	setEmployeePrimaryBeneficiary: any;
	childrenPrimaryBeneficiary: any;
	setChildrenPrimaryBeneficiary: any;
	spousePrimaryBeneficiary: any;
	setSpousePrimaryBeneficiary: any;

	// contingent beneficiary
	employeeContingentBeneficiary: any;
	setEmployeeContingentBeneficiary: any;
	childrenContingentBeneficiary: any;
	setChildrenContingentBeneficiary: any;
	spouseContingentBeneficiary: any;
	setSpouseContingentBeneficiary: any;
	dependents: any;
	member: any;
	spouse: any;
	coverage_for: any;
	isChild: boolean;
	isFamilyProtection?: boolean;
	employeeHasBeneficiary?: boolean;
	spouseHasBeneficiary?: boolean;
	childHasBeneficiary?: boolean;
};

const EditTermLifeToAge: React.FC<EditFamilyProtectionBeneficiary> = ({
	employeePrimaryBeneficiary,
	setEmployeePrimaryBeneficiary,
	childrenPrimaryBeneficiary,
	setChildrenPrimaryBeneficiary,
	spousePrimaryBeneficiary,
	setSpousePrimaryBeneficiary,
	employeeContingentBeneficiary,
	setEmployeeContingentBeneficiary,
	childrenContingentBeneficiary,
	setChildrenContingentBeneficiary,
	spouseContingentBeneficiary,
	setSpouseContingentBeneficiary,
	dependents,
	member,
	spouse,
	coverage_for,
	isChild,

	isFamilyProtection,
	employeeHasBeneficiary,
	spouseHasBeneficiary,
	childHasBeneficiary
}) => {
	//  Show conditions
	const showEmployee =
		member &&
		(coverage_for === "Employee Only" ||
			coverage_for === "Employee & Children" ||
			coverage_for === "Employee & Spouse" ||
			coverage_for === "Employee & Family") &&
		(!isFamilyProtection || employeeHasBeneficiary); // Family Protection check

	const showSpouse =
		spouse &&
		(coverage_for === "Employee & Spouse" ||
			coverage_for === "Spouse Only" ||
			coverage_for === "Spouse & Children" ||
			coverage_for === "Employee & Family") &&
		(!isFamilyProtection || spouseHasBeneficiary); //  Family Protection check

	const showChild =
		(coverage_for === "Employee & Children" ||
			coverage_for === "Spouse & Children" ||
			coverage_for === "Employee & Family") &&
		(!isFamilyProtection || childHasBeneficiary); // ← Family Protection check

	return (
		<div>
			<Grid container justifyContent="center" justifyItems="center" alignItems="center">
				{/* ── Employee section ── */}
				{showEmployee && (
					<Grid item xl={12} lg={12} md={12}>
						<VEBBeneficiary
							primaryBeneficiary={employeePrimaryBeneficiary}
							setPrimaryBeneficiary={setEmployeePrimaryBeneficiary}
							contingentBeneficiary={employeeContingentBeneficiary}
							setContingentBeneficiary={setEmployeeContingentBeneficiary}
							member={member}
							employee={member}
							dependents={dependents}
						/>
					</Grid>
				)}

				{/* ── Spouse section ── */}
				{showSpouse && (
					<Grid item xl={12} lg={12} md={12}>
						<div className="theme-plan-section-margin" />
						<VEBBeneficiary
							primaryBeneficiary={spousePrimaryBeneficiary}
							setPrimaryBeneficiary={setSpousePrimaryBeneficiary}
							contingentBeneficiary={spouseContingentBeneficiary}
							setContingentBeneficiary={setSpouseContingentBeneficiary}
							member={spouse}
							employee={member}
							dependents={dependents}
						/>
					</Grid>
				)}

				{/* ── Child section ── */}
				{showChild && (
					<Grid item xl={12} lg={12} md={12}>
						<div className="theme-plan-section-margin" />
						<VEBBeneficiary
							primaryBeneficiary={childrenPrimaryBeneficiary}
							setPrimaryBeneficiary={setChildrenPrimaryBeneficiary}
							contingentBeneficiary={childrenContingentBeneficiary}
							setContingentBeneficiary={setChildrenContingentBeneficiary}
							isChild
							member={member}
							employee={member}
							dependents={dependents}
						/>
					</Grid>
				)}
			</Grid>
		</div>
	);
};

export default EditTermLifeToAge;
